<template>
  <div>
    <div class="lot-title-div">
      <em style="color:#007AFF;">【{{ formatEnum(outData.auctionModality, auctionModalityOptions) }}】</em>
      {{ outData.lotName }}
    </div>
    <div class="lot-content-div">
      <div class="lot-content-left">
        <!-- 主展示区域：图片和视频切换显示 -->
        <div class="big-img-div">
          <!-- 视频播放区域 -->
          <div v-if="showVideo && isCurrentVideo" class="video-display">
            <video
                ref="videoPlayer"
                :src="currentMediaLink"
                controls
                style="width:100%;height:100%;background:#000;"
                @click="toggleVideoPlay"
                @loadedmetadata="onVideoLoaded">
              您的浏览器不支持视频播放
            </video>
          </div>

          <!-- 图片展示区域 -->
          <div v-else-if="!isCurrentVideo && currentMediaLink && !mediaLoading" @click="openFullscreen">
            <imgZoom
                :height="220"
                :minIMGsrc="currentMediaLink"
                :scale="3"
                :width="400"/>
          </div>
          <div v-if="mediaLoading" class="loading-placeholder">
            <i class="el-icon-loading" style="font-size: 24px; color: #ccc;"></i>
            <p>加载中...</p>
          </div>

          <div v-else-if="isCurrentVideo && mediaLoading === false" class="video-placeholder" @click="playCurrentVideo">
            <i class="el-icon-video-play" style="font-size: 48px; color: #666;"></i>
            <p>点击播放视频</p>
          </div>
        </div>

        <!-- 缩略图区域 -->
        <div class="small-img-div">
          <el-button
              :disabled="currentMediaIndex <= 0"
              circle
              class="nav-btn nav-btn-left"
              icon="el-icon-arrow-left"
              size="mini"
              @click="prevMedia">
          </el-button>
          <div class="img-list-container">
            <div class="img-scroll-wrapper">
              <!-- 遍历所有媒体文件（包含图片和视频） -->
              <div v-for="(media, index) in mediaList" :key="'media-' + index" style="display: inline;">
                <!-- 图片类型 -->
                <img
                    v-if="isImageFile(media.link)"
                    :id="'content'+media.id"
                    :key="media.id"
                    :alt="media.name"
                    :class="['content-img-dom', currentMediaIndex === index ? 'active-img' : '']"
                    :src="media.link"
                    :style="{opacity: currentMediaIndex === index ? 1 : 0.6}"
                    @click="changeShowMedia(media.id, index)">

                <!-- 视频类型 -->
                <div
                    v-else-if="isVideoFile(media.link)"
                    :id="'content'+media.id"
                    :key="media.id"
                    :class="['content-img-dom', currentMediaIndex === index ? 'active-img' : '', 'video-thumb']"
                    :style="{opacity: currentMediaIndex === index ? 1 : 0.6}"
                    class="video-thumb-preview"
                    @click="changeShowMedia(media.id, index)">
                  <!-- 视频预览图 -->
                  <video
                      :src="media.link"
                      class="video-preview"
                      muted
                      preload="metadata"
                      @loadeddata="onVideoPreviewLoaded(media.id)">
                  </video>
                  <!-- 视频播放图标 -->
                  <div class="video-play-overlay">
                    <i class="el-icon-video-play"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-button
              :disabled="(outData.lotImg && currentImageIndex >= outData.lotImg.length - 1) || currentMediaIndex >= mediaList.length - 1"
              circle
              class="nav-btn nav-btn-right"
              icon="el-icon-arrow-right"
              size="mini"
              @click="nextMedia">
          </el-button>
        </div>
        <div class="view-count-div">
          <img class="eye-img-class" src="../../../public/img/eye.png">
          <span class="view-count-label">围观次数：</span>
          <span class="view-count-value">{{ outData.viewCount }}次</span>
          <template v-if="applyState">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="view-count-label">我的竞买号：</span>
            <span class="view-count-value">{{ bidCode }}</span>
          </template>
          <template v-if="outData.auctionWay==2">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="view-count-label">计量单位：</span>
            <span class="view-count-value">{{ outData.unit }}</span>
          </template>
        </div>
      </div>
      <div class="lot-content-right">
        <div class="time-type-div">
          <template v-if="outData.auctionStatus!=1&&outData.auctionStatus!=2">
            <template v-if="outData.auctionStatus==0">
              <span class="ready-type-span-class">即将开始</span>
              <countDown v-if="showStartCountdown"
                         :key="'start-'+outLotId+'-'+startTimeTimestamp"
                         v-slot="timeObj" :end="startTimeTimestamp"
                         :isMilliSecond="true" class="timetxt"
                         style="margin-left:10px;display:inline-block;"
                         @end="onStartCountdownEnd">
                <span class="timetxt" style="margin-left:0;font-size:15px;">距开拍：</span>
                <span class="countdown J_TimeLeft" style="margin-left:5px;">
                  <var class="day">{{ timeObj.d }}</var>
                  <em>天 </em>
                  <var class="hour">{{ timeObj.hh }}</var>
                  <em>时 </em>
                  <var class="minute">{{ timeObj.mm }}</var>
                  <em>分 </em>
                  <var class="second">{{ timeObj.ss }}</var>
                  <em>秒 </em>
                </span>
              </countDown>
              <span v-else
                    style="color:#000;margin-left:10px;font-size:15px;">拍卖会预计{{
                  meetingData.startAuctionTime
                }}开始</span>
            </template>
            <template v-else>
              <span v-if="outData.auctionStatus!=null"
                    class="end-type-span-class">{{
                  outData.auctionStatus == 3 ? '已成交' : (outData.backOutStatus == 1 ? '已撤拍' : '已流拍')
                }}</span>
              <span v-if="outData.auctionStatus!=null"
                    style="color:#000;margin-left:10px;font-size:15px;">{{ outData.endTime }}&nbsp;&nbsp;结束</span>
            </template>
          </template>
          <template v-if="outData.auctionStatus==1||outData.auctionStatus==2">
            <countDown v-if="outData.auctionStatus==1" :key="outData.round+executeTime" v-slot="timeObj" :end="executeTime"
                       :isMilliSecond="false" class="timetxt" @end="onCountdownEnd">
              <el-button round size="mini" type="danger">
                {{ outData.auctionStatus == 1 ? '正在进行' : '请等待拍卖师操作' }}
              </el-button>
              <span class="timetxt"
                    style="margin-left: 10px;">{{
                  outData.auctionModality == 2 ? '距下次降价' : (outData.auctionProgress == 1 ? '自由竞价倒计时：' : '限时竞价倒计时：')
                }}
              </span>
              <span class="countdown J_TimeLeft" style="margin-left: 10px;">
                <var class="day">{{ timeObj.d }}</var>
                <em>天 </em>
                <var class="hour">{{ timeObj.hh }}</var>
                <em>时 </em>
                <var class="minute">{{ timeObj.mm }}</var>
                <em>分 </em>
                <var class="second">{{ timeObj.ss }}</var>
                <em>秒 </em>
              </span>
            </countDown>
            <template v-else>
              <el-button round size="mini" type="danger">
                {{ outData.auctionStatus == 1 ? '正在进行' : '请等待拍卖师操作' }}
              </el-button>
              <span class="timetxt"
                    style="margin-left: 10px;">{{
                  outData.auctionModality == 2 ? '距下次降价' : (outData.auctionProgress == 1 ? '自由竞价倒计时：' : '限时竞价倒计时：')
                }}
              </span>
              <span class="countdown J_TimeLeft">
                <var class="day">{{ countDown.day }} </var>
                <em> 天</em>
                <var class="hour">{{ countDown.hour }} </var>
                <em> 时</em>
                <var class="minute">{{ countDown.minute }} </var>
                <em> 分</em>
                <var class="second">{{ countDown.second }} </var>
                <em> 秒</em>
              </span>
            </template>
          </template>
        </div>
        <div class="lot-content-quoted-div">
          <template v-if="outData.auctionStatus==0">
            <div style="padding-left: 20px;">
              <div class="price-div-class">
                <span class="price-label">起拍价：</span>
                <span class="price-value" style="color:rgb(30,169,106);font-size:22px;">{{outData.startPrice}}{{ priceUnit }}</span>
              </div>
            </div>
          </template>
          <template v-else-if="outData.auctionStatus!=-1">
            <div class="price-div-class">
              <span class="price-label">{{ outData.auctionStatus == 3 ? '成交价：' : '当前价：' }}</span>
              <span class="price-value">{{ parseFloat(outData.currentQuoted).toFixed(2) }}{{ priceUnit }}</span>
              <span v-if="outData.bidderName || outData.bidCode" class="bidder-info">
              <span class="price-label">出价人：（</span>
              <span v-if="isCurrentUserBidder" class="bidder-self">您本人（竞买号:{{ outData.bidCode }}）</span>
              <span v-else-if="outData.bidCode" class="bidder-code">竞买号:{{ outData.bidCode }}</span>
                <span v-else class="bidder-code">{{ outData.bidderName }}</span>
                  ）
              </span>
            </div>
          </template>
          <div>
            <template v-if="outData.auctionStatus==-1||outData.auctionStatus==3">
              <div class="result_span">
                本标的已{{ outData.auctionStatus == 3 ? '成交' : (outData.backOutStatus == 1 ? '撤拍' : '流拍') }}
              </div>
              <span v-if="meetingData.meetingWay === 1" class="meeting-platform-info">本标的在<span style="color: red">{{
                  meetingData.meetingPlatform
                }}</span>在线拍卖</span>
            </template>
            <template v-else>
              <template v-if="applyState">
                <template v-if="outData.auctionStatus==0">
                  <el-button v-if="applyState === 1" disabled style="width:210px;margin-left:60px;margin-top: 20px;"
                             type="warning">
                    报名审核中
                  </el-button>
                  <el-button
                      v-if="applyState === 3"
                      style="width:210px;margin-left:60px;margin-top: 20px;"
                      type="primary"
                      @click="toApply">
                    重新报名
                  </el-button>
                  <div v-if="applyState === 3" class="deposit-info">
                    <span class="deposit-text">需缴纳保证金：<strong>{{ outData.depositePrice || 0 }}元</strong></span>
                  </div>

                  <el-upload
                      v-if="applyState === 2 && (applyFileState === 0 || applyFileState === 3) && meetingData.isApplyMaterials !== 0"
                      :action="uploadAction"
                      :before-upload="beforeUpload"
                      :headers="uploadHeaders"
                      :on-error="handleMaterialError"
                      :on-success="handleMaterialSuccess"
                      :show-file-list="false"
                      style="display: inline-block;width:150px;margin-left:60px;margin-top: 20px;">
                    <el-button
                        size="small"
                        style="width:150px" type="primary">
                      {{ applyFileState === 3 ? '重新上传材料' : '上传报名材料' }}
                    </el-button>
                  </el-upload>

                  <el-button
                      v-if="applyState === 2 && (applyFileState === 0 || applyFileState === 3) && meetingData.isApplyMaterials !== 0"
                      size="small"
                      style="display: inline-block; width:150px;margin-left:20px;margin-top: 20px; vertical-align: top;"
                      type="success"
                      @click="downloadBiddingRules">
                    下载竞价规则
                  </el-button>

                  <el-button v-if="applyFileState === 1" disabled
                             style="width:210px;margin-left:60px;margin-top: 20px;"
                             type="warning">报名材料审核中
                  </el-button>
                  <el-button
                      v-if="(applyFileState === 2 || (applyState === 2 && meetingData.isApplyMaterials == 0)) && meetingData.meetingWay === 0"
                      disabled
                      style="width:210px;margin-left:60px;margin-top: 20px;"
                      type="primary">等待开拍
                  </el-button>
                  <span v-if=" meetingData.meetingWay === 1" class="meeting-platform-info">报名成功后请到<span
                      style="color: red">{{ meetingData.meetingPlatform }} </span>进行在线拍卖 </span>


                  <!-- 新增：已登录状态的保证金信息 -->

                </template>
                <template v-else>
                  <div class="price-div-class">
                    <template
                        v-if="(applyFileState === 2 || (applyState === 2 && meetingData.isApplyMaterials == 0)) && canQuote">
                      <span class="price-label">出价：</span>
                      <el-input-number v-if="outData.auctionModality!=2 && outData.round==0" v-model="activeQuoted"
                                       :disabled='outData.auctionStatus!=1 || applyState==1' :min="parseFloat(outData.currentQuoted)" :precision="2"
                                       :step="parseFloat(outData.bidIncrement)" class="no-manual-input"
                                       controls-only
                                       readonly
                                       size="small"
                                       style="width:270px"
                                       @focus="handleInputFocus"></el-input-number>
                      <el-input-number v-else-if="outData.auctionModality!=2" v-model="activeQuoted"
                                       :disabled='outData.auctionStatus!=1 || applyState==1'
                                       :min="parseFloat(outData.currentQuoted) + parseFloat(outData.bidIncrement)" :precision="2"
                                       :step="parseFloat(outData.bidIncrement)" class="no-manual-input"
                                       controls-only
                                       readonly
                                       size="small"
                                       style="width:270px"
                                       @focus="handleInputFocus"></el-input-number>
                      <el-input-number v-else :precision="2" :value="outData.currentQuoted" class="no-manual-input"
                                       controls-only
                                       disabled
                                       readonly
                                       size="small"
                                       style="width:270px"
                                       @focus="handleInputFocus"></el-input-number>
                      <el-button v-if="(applyFileState === 2 || (applyState === 2 && meetingData.isApplyMaterials == 0)) && canQuote"
                                 :key="outData.id"
                                 :disabled="outData.auctionStatus!=1"
                                 style="width:100px;margin-left:40px;" type="primary" @click="quotedPrice">报价
                      </el-button>
                    </template>
                    <template v-else>
                      <span class="price-label" style="color: red"> {{ cannotQuoteReason }}</span>
                    </template>
                  </div>
                </template>
              </template>
              <div v-else class="quoted-apply">
                <el-button v-if="isApplyTimeValid" style="width:150px" type="danger" @click="toApply">报名</el-button>

                <!-- 未登录状态显示保证金信息 -->
                <div v-if="isApplyTimeValid" class="deposit-info">
                  <span class="deposit-text">需缴纳保证金：<strong>{{ outData.depositePrice || 0 }}元</strong></span>
                </div>
                <span v-if="meetingData.meetingWay === 1" class="meeting-platform-info">报名成功后请至<span
                    style="color: red">{{ meetingData.meetingPlatform }}</span>在线拍卖</span>
              </div>
            </template>
          </div>
        </div>
        <div class="lot-content-info-div">
          <div class="lot-content-info-row flex-row">
            <span class="span3-label">起拍价</span>
            <span class="span3-value">{{ outData.startPrice }}{{ priceUnit }}</span>
            <span class="span3-label">保证金</span>
            <span class="span3-value">{{ outData.depositePrice }}元</span>
            <span class="span3-label">{{ outData.auctionModality != 2 ? '加价' : '降价' }}幅度</span>
            <span class="span3-value">{{ outData.bidIncrement }}元</span>
          </div>
          <div class="flex-row">
            <span class="span3-label">评估价</span>
            <span class="span3-value">{{ outData.evalPrice != null ? outData.evalPrice+'元' : '无' }}</span>
            <span class="span3-label">保留价</span>
            <span class="span3-value">{{ outData.isReservePrice == 1 ? '有' : '无' }}</span>
            <span class="span3-label">评估费</span>
            <span class="span3-value">{{ outData.evaluationFee != null ? outData.evaluationFee + '元' : '无' }}</span>
          </div>
          <div class="flex-row">
            <span class="span3-label"
                  style="font-size: 12px;">{{ outData.auctionModality != 2 ? "自由竞价时间" : "" }}</span>
            <span class="span3-value"
                  style="font-size: 12px;width:185px">
              {{ outData.auctionModality != 2 ? formatFreeTime(outData.freeBidTime, 1) : "" }}</span>
            <span class="span3-label"
                  style="font-size: 12px;">{{ outData.auctionModality != 2 ? "限时竞价时间" : "降价周期" }}</span>
            <span class="span3-value"
                  style="font-size: 12px;width:185px">{{ formatFreeTime(outData.limitBidTime, 1) }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :fullscreen="true"
        :modal="true"
        :visible.sync="fullscreenVisible"
        custom-class="fullscreen-dialog"
        @close="closeFullscreen">
      <div class="fullscreen-content">
        <div class="fullscreen-header">
          <div class="fullscreen-title">
            <span>{{ outData.lotName }}</span>
            <span class="fullscreen-counter">图片 {{ currentMediaIndex + 1 }} / {{ mediaList.length }}</span>
          </div>
          <div class="fullscreen-actions">
            <el-button
                :disabled="currentMediaIndex <= 0"
                circle
                class="fullscreen-nav-btn"
                size="mini"
                @click="prevMedia">
              <i class="el-icon-arrow-left"></i>
            </el-button>
            <el-button
                :disabled="currentMediaIndex >= mediaList.length - 1"
                circle
                class="fullscreen-nav-btn"
                size="mini"
                @click="nextMedia">
              <i class="el-icon-arrow-right"></i>
            </el-button>
            <el-button
                class="fullscreen-close-btn"
                type="text"
                @click="closeFullscreen">
              <i class="el-icon-close"></i>
              关闭 (ESC)
            </el-button>
          </div>
        </div>
        <div class="fullscreen-body">
          <img
              :src="currentMediaLink"
              alt="全屏图片"
              class="fullscreen-image"
              @click="closeFullscreen">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {cmsGetApplyState, getBidCode, updateApplyFile} from '@/api/biz/auction/lotApply'
import {cmsQuoted, priceList} from '@/api/biz/auction/lotQuoted'
import imgZoom from './s-imgZoom';
import countDown from './countdown.vue'
import auctionModalityOptions from "@/enum/auctionModalityOptions";
import {getToken} from "@/util/auth";
import {getMeetingDetail} from "@/api/biz/auction/auctionMeeting";

export default {
  name: "HallLotContent",
  props: ['outLotId', 'outData', 'meetingData'],
  components: {imgZoom, countDown},
  computed: {
    token() {
      return getToken();
    },
    uploadAction() {
      return `/api/sino-resource/oss/endpoint/put-file?${this.website.tokenHeader}=${getToken()}`;
    },
    uploadHeaders() {
      return {
        'Authorization': 'Basic c2lubzpzaW5vX3NlY3JldA==',
        'Sino-Auth': this.token || ''
      };
    },
    isLogin() {
      return this.userInfo.user_name ? 1 : 0;
    },
    executeTime() {
      return new Date(this.outData.executeTime).getTime() + 1000 * this.outData.timeRemaining;
    },
    ...mapGetters(["userInfo"]),
    isApplyPassed() {
      // 当 applyState 的值为 2 时，表示报名成功
      return this.applyState === 2;
    },
    isApplyTimeValid() {
      if (!this.meetingData || !this.meetingData.applyEndTime) {
        return true; // 如果没有截止时间，默认允许报名
      }

      const applyEndTime = new Date(this.meetingData.applyEndTime).getTime();
      const currentTime = new Date().getTime();

      return currentTime <= applyEndTime;
    },
    isCurrentUserBidder() {
      if (!this.outData || !this.outData.bidderId || !this.userInfo.user_id) {
        return false;
      }
      return this.outData.bidderId == this.userInfo.user_id;
    },

    // 统一媒体文件列表
    mediaList() {
      return this.outData.lotImg || [];
    },

    // 当前显示的媒体链接
    currentMediaLink() {
      if (this.mediaList.length === 0) return '';
      return this.mediaList[this.currentMediaIndex].link;
    },

    // 当前是否为视频
    isCurrentVideo() {
      return this.isVideoFile(this.currentMediaLink);
    },

    // 是否是线下拍卖
    isOfflineAuction() {
      return this.meetingData && this.meetingData.meetingWay === 1;
    },

    // 拍卖平台名称
    meetingPlatform() {
      return this.meetingData && this.meetingData.meetingPlatform ? this.meetingData.meetingPlatform : '指定平台';
    },
    priceUnit() {
      return this.outData.auctionWay === 1 ? '元' : `元/${this.outData.unit}`;
    },
    // 开拍时间的时间戳（毫秒）
    startTimeTimestamp() {
      if (!this.meetingData || !this.meetingData.startAuctionTime) return 0;
      return new Date(this.meetingData.startAuctionTime).getTime();
    }
  },
  data() {
    return {
      currentImageIndex: 0,
      mediaLoading: true,  // 添加媒体加载状态
      activeLotImgLink: '',
      applyState: 0,
      applyFileState: 0,
      bidCode: 0,
      activeQuoted: '',
      countDown: {day: 0, hour: 0, minute: 0, second: 0,},
      activeTimeCountDown: null,
      countDownTimer: null,
      auctionModalityOptions: [],

      // 媒体相关数据
      currentMediaIndex: 0, // 当前媒体索引
      videoPreviews: {}, // 存储视频预览信息

      // 视频相关数据
      showVideo: false, // 是否显示视频
      videoPlayer: null, // 视频播放器实例
      isPlaying: false, // 是否正在播放
      showVideoControls: true, // 是否显示控制栏
      videoDuration: '00:00', // 视频时长

      // 新增全屏相关数据
      fullscreenVisible: false, // 是否显示全屏模态框

      // 新增：报名相关
      canQuote: false,
      cannotQuoteReason: '',
      isMaterialUploaded: false,
      uploadedFileInfo: null,

      // 开拍前倒计时（距离开拍10分钟内显示）
      showStartCountdown: false,
      startCountdownCheckTimer: null,
    }
  },
  watch: {
    outLotId: {
      handler(newId, oldId) {
        if (newId !== oldId) {
          // 重置相关状态
          this.resetComponentState();
          // 重新获取数据
          this.getApplyState();
        }
      },
      immediate: true
    },
    meetingData: {
      handler(newVal) {
        if (newVal && newVal.id && this.outLotId) {
          this.getApplyState();
        }
      },
      immediate: false
    }
  },
  methods: {
    priceList,
    handleInputFocus(event) {
      // 立即失去焦点，阻止输入
      event.target.blur();
    },
    // 监听输入事件，阻止手动输入
    handleInput(event) {
      event.preventDefault();
      return false;
    },
    resetComponentState() {
      // 清理定时器
      if (this.countDownTimer) {
        clearInterval(this.countDownTimer);
        this.countDownTimer = null;
      }
      if (this.startCountdownCheckTimer) {
        clearInterval(this.startCountdownCheckTimer);
        this.startCountdownCheckTimer = null;
      }
      // 关闭全屏（新增）
      this.closeFullscreen();
      // 关闭视频
      this.closeVideo();

      // 重置相关数据
      this.activeQuoted = 0;
      this.applyState = 0;
      this.applyFileState = 0;
      this.bidCode = 0;
      this.countDowm = {day: 0, hour: 0, minute: 0, second: 0};
      this.showStartCountdown = false;
      this.currentMediaIndex = 0;
      this.videoPreviews = {};
      this.canQuote = false;
      this.cannotQuoteReason = '';
      this.isMaterialUploaded = false;
      this.uploadedFileInfo = null;
    },

    // 判断是否为图片
    isImageFile(url) {
      if (!url) return false;
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const lowerUrl = url.toLowerCase();
      return imageExtensions.some(ext => lowerUrl.endsWith(ext));
    },

    // 判断是否为视频
    isVideoFile(url) {
      if (!url) return false;
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.m3u8'];
      const lowerUrl = url.toLowerCase();
      return videoExtensions.some(ext => lowerUrl.endsWith(ext));
    },

    // 切换到上一个媒体
    prevMedia() {
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex--;
        this.changeShowMedia(this.mediaList[this.currentMediaIndex].id, this.currentMediaIndex);
        this.scrollToCurrentMedia();
      }
    },

    // 切换到下一个媒体
    nextMedia() {
      if (this.currentMediaIndex < this.mediaList.length - 1) {
        this.currentMediaIndex++;
        this.changeShowMedia(this.mediaList[this.currentMediaIndex].id, this.currentMediaIndex);
        this.scrollToCurrentMedia();
      }
    },

    // 新增：关闭视频
    closeVideo() {
      this.showVideo = false;
      if (this.videoPlayer) {
        this.videoPlayer.pause();
        this.isPlaying = false;
        this.videoPlayer = null;
      }
    },

    // 新增：切换视频播放/暂停
    toggleVideoPlay() {
      if (this.videoPlayer) {
        if (this.videoPlayer.paused) {
          this.videoPlayer.play();
          this.isPlaying = true;
        } else {
          this.videoPlayer.pause();
          this.isPlaying = false;
        }
      }
    },

    // 新增：视频元数据加载完成
    onVideoLoaded() {
      if (this.videoPlayer) {
        const seconds = this.videoPlayer.duration;
        if (seconds) {
          const mins = Math.floor(seconds / 60);
          const secs = Math.floor(seconds % 60);
          this.videoDuration = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
      }
    },

    // 视频预览加载完成
    onVideoPreviewLoaded(mediaId) {
      // 可以在这里获取视频时长等信息
      const videoElement = document.querySelector(`#content${mediaId} video`);
      if (videoElement) {
        this.videoPreviews[mediaId] = {
          duration: videoElement.duration,
          ready: true
        };
      }
    },

    // 切换显示的媒体
    changeShowMedia(id, index = null) {
      this.mediaLoading = true;
      this.$nextTick(() => {
        if (index !== null) {
          this.currentMediaIndex = index;
        } else {
          const mediaIndex = this.mediaList.findIndex(media => media.id == id);
          if (mediaIndex !== -1) {
            this.currentMediaIndex = mediaIndex;
          }
        }

        // 更新大图显示区域的链接
        this.activeLotImgLink = this.mediaList[this.currentMediaIndex].link;

        if (this.isCurrentVideo) {
          // 对于视频，我们不立即播放，而是显示占位符
          this.showVideo = false;
          this.closeVideo();
        } else {
          // 对于图片，关闭视频功能
          this.closeVideo();
          this.showVideo = false;
        }

        // 高亮当前缩略图
        this.highlightCurrentMedia();
        this.mediaLoading = false;
      });
    },

    // 播放当前视频
    playCurrentVideo() {
      if (!this.isCurrentVideo) return;

      this.showVideo = true;
      this.$nextTick(() => {
        const videoElement = this.$refs.videoPlayer;
        if (videoElement) {
          this.videoPlayer = videoElement;
          videoElement.src = this.currentMediaLink;

          videoElement.load();
          videoElement.play().then(() => {
            this.isPlaying = true;
          }).catch(e => {
            console.log('视频播放失败:', e);
            this.showVideoControls = true;
          });
        }
      });
    },

    // 高亮当前媒体
    highlightCurrentMedia() {
      this.mediaList.forEach(media => {
        const element = document.getElementById('content' + media.id);
        if (element) {
          if (media.id === this.mediaList[this.currentMediaIndex].id) {
            element.style.borderColor = 'red';
          } else {
            element.style.borderColor = 'transparent';
          }
        }
      });
    },

    // 滚动到当前媒体
    scrollToCurrentMedia() {
      this.$nextTick(() => {
        const container = document.querySelector('.img-list-container');
        const wrapper = document.querySelector('.img-scroll-wrapper');
        const mediaElement = document.getElementById('content' + this.mediaList[this.currentMediaIndex].id);

        if (container && wrapper && mediaElement) {
          const containerWidth = container.offsetWidth;
          const mediaWidth = mediaElement.offsetWidth + 4;
          const mediaOffset = mediaElement.offsetLeft;

          const scrollX = mediaOffset - (containerWidth - mediaWidth) / 2;
          wrapper.style.transform = `translateX(${-scrollX}px)`;
          wrapper.style.transition = 'transform 0.3s ease';
        }
      });
    },

    handleMaterialSuccess(response) {
      if (this.applyFileState === 3) {
        this.isMaterialUploaded = false; // 重置上传状态
      } else if (this.applyFileState === 1 || this.applyFileState === 2) {
        this.$message.info('报名材料已上传，无需重复上传');
        return;
      }

      this.isMaterialUploaded = true;
      this.applyFileState = 1;
      this.uploadedFileInfo = response.data;
      this.$message.success('材料上传成功');
      this.submitApplyWithFile()
    },

    submitApplyWithFile() {
      if (!this.uploadedFileInfo) {
        this.$message.warning('未获取到上传文件信息');
        return;
      }
      const applyParams = {
        meetingId: this.outData.meetingId,
        bidderId: this.userInfo.user_id,
        applyFile: this.uploadedFileInfo.link,
        applyFileState: 1
      };
      updateApplyFile(applyParams)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('申请材料提交成功');
            } else {
              this.$message.error('申请材料提交失败: ' + res.data.message);
            }
          })
          .catch(err => {
            console.error('申请材料提交异常:', err);
            this.$message.error('申请材料提交异常');
          });
    },

    handleMaterialError() {
      this.$message.error('材料上传失败');
      // 如果之前是状态3（审核不通过），保持状态不变
      if (this.applyFileState !== 3) {
        this.applyFileState = 0;
        this.isMaterialUploaded = false;
      }
    },

    beforeUpload(file) {
      if (this.applyFileState === 1 || this.applyFileState === 2) {
        this.$message.info('报名材料已上传，无需重复上传');
        return false;
      }
      // 检查文件类型，只允许PDF格式
      const isPdf = file.type === 'application/pdf' || file.name.endsWith('.pdf');
      if (!isPdf) {
        this.$message.error('只能上传PDF格式文件!');
        return false;
      }
      // 文件大小验证
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!');
      }
      return isLt50M;
    },

    // 格式化数据
    formatEnum(key, child) {
      for (var index in child) {
        if (child[index].key == key) {
          return child[index].value;
        }
      }
      return "";
    },

    formatFreeTime(time, type) {
      let t = parseInt(time);
      return (type == 1 ? parseInt(t / (24 * 60 * 60)) + '天' : '') + parseInt(t / (60 * 60) % 24) + '时' + parseInt(t / 60 % 60) + '分' + parseInt(t % 60) + '秒';
    },

    async quotedPrice() {
      const lotQuoted = {
        meetingId: this.outData.meetingId,
        lotId: this.outLotId,
        quoted: this.outData.auctionModality !== 2 ? this.activeQuoted : this.outData.currentQuoted,
        round: this.outData.round,
        priceState: 1,
        bidderId: this.userInfo.user_id,
        meetingType: this.meetingData.meetingType
      }
      let isQuoted = true;
      if (this.userInfo.user_id === this.outData.bidderId) {
        await this.$confirm('当前已领先报价，是否继续报价?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          isQuoted = true;
        }).catch(() => {
          isQuoted = false;
        })
      } else {
        await this.$confirm('尊敬的 ' + this.bidCode + ' 号，您提交的竞价为：人民币 ' + lotQuoted.quoted + ' 元', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          isQuoted = true;
        }).catch(() => {
          isQuoted = false;
        })
      }
      if (!isQuoted) {
        return;
      }

      cmsQuoted(lotQuoted).then(res => {
        let data = res.data.data;
        if (data === 99) {
          this.$message({type: 'success', message: '报价成功！'})
        } else if (data === 2 || data === 3 || data === -1) {
          this.$message({type: 'warning', message: '标的当前状态下无法报价！'})
        } else if (data === 0) {
          this.$message({type: 'warning', message: '有其他竞买人报价领先于您的报价！'})
        } else if (data === 2024) {
          this.$message({type: 'warning', message: '超出授权数量,无法报价！'})
        }
      })
    },

    getApplyState() {
      if (this.isLogin) {
        cmsGetApplyState({lotId: this.outLotId, bidderId: this.userInfo.user_id}).then(res => {
          this.applyState = res.data.data.applyState;
          this.applyFileState = res.data.data.applyFileState;
          this.canQuote = res.data.data.canQuote;
          this.cannotQuoteReason = res.data.data.cannotQuoteReason;
          if (this.applyFileState === 1 || this.applyFileState === 2) {
            this.isMaterialUploaded = true;
          } else if (this.applyFileState === 3) {
            // 审核不通过状态，允许重新上传
            this.isMaterialUploaded = false;
          }
          if (this.meetingData && this.meetingData.id && this.applyState !== 0) {
            getBidCode({meetingId: this.meetingData.id, bidderId: this.userInfo.user_id}).then(res => {
              if (res && res.data && res.data.data) {
                this.bidCode = res.data.data.bidCode;
              }
            })
          }
        })

      } else {
        this.applyState = 0;
        this.applyFileState = 0;
      }
    },

    toApply() {
      if (this.applyState === 2) {
        this.$message.info('您已报名成功，无需重复报名');
        return;
      }
      if (this.isLogin) {
        if (this.userInfo.companyId == null || this.userInfo.isAuth === 0) {
          return this.$message({type: 'warning', message: '请完成实名认证审核'})
        }
        let routeQuery = {
          lotId: this.outLotId,
          meetingId: this.outData.meetingId
        };
        if (this.applyState === 3) {
          routeQuery.reApply = 'true';
        }
        this.$router.push({
          path: "/toApply",
          query: routeQuery
        });
      } else {
        sessionStorage.setItem('activeLotId', this.outLotId);
        this.$router.push("/login");
      }
    },

    downloadBiddingRules() {
      if (!this.isApplyPassed) {
        this.$message.warning('请先通过报名审核');
        return;
      }

      // 调用 getMeetingDetail 接口获取下载地址
      getMeetingDetail(this.outData.meetingId).then(res => {
        if (res.data.code === 200 && res.data.data) {
          const materialsName = res.data.data.materialsName;
          if (materialsName) {
            // 创建下载链接并触发下载
            const link = document.createElement('a');
            link.href = materialsName;
            link.download = ''; // 空值表示使用服务器提供的文件名
            link.target = '_blank';
            link.click();
          } else {
            this.$message.warning('未找到竞价规则文件');
          }
        } else {
          this.$message.error('获取竞价规则失败: ' + (res.data.message || '未知错误'));
        }
      }).catch(err => {
        console.error('获取竞价规则异常:', err);
        this.$message.error('获取竞价规则异常');
      });
    },

    // 切换到下一张图片
    nextImage() {
      if (this.currentImageIndex < this.outData.lotImg.length - 1) {
        this.currentImageIndex++;
        this.changeShowImg(this.outData.lotImg[this.currentImageIndex].id, this.currentImageIndex);
        this.scrollToCurrentImage();
      }
    },

    // 滚动到当前图片位置
    scrollToCurrentImage() {
      this.$nextTick(() => {
        const container = document.querySelector('.img-list-container');
        const wrapper = document.querySelector('.img-scroll-wrapper');
        const imgElement = document.getElementById('content' + this.outData.lotImg[this.currentImageIndex].id);

        if (container && wrapper && imgElement) {
          const containerWidth = container.offsetWidth;
          const imgWidth = imgElement.offsetWidth + 4; // 4是margin
          const imgOffset = imgElement.offsetLeft;

          // 计算滚动位置，使当前图片居中显示
          const scrollX = imgOffset - (containerWidth - imgWidth) / 2;

          // 使用 transform 实现平滑滚动
          wrapper.style.transform = `translateX(${-scrollX}px)`;
          wrapper.style.transition = 'transform 0.3s ease';
        }
      });
    },

    // 修改 changeShowImg 方法以支持索引参数
    changeShowImg(id, index = null) {
      this.$nextTick(() => {
        // 如果传入了索引，更新当前图片索引
        if (index !== null) {
          this.currentImageIndex = index;
        } else {
          // 如果没有传入索引，则根据ID查找索引
          const imgIndex = this.outData.lotImg.findIndex(img => img.id == id);
          if (imgIndex !== -1) {
            this.currentImageIndex = imgIndex;
          }
        }

        this.outData.lotImg.forEach(e => {
          if (e.id === id) {
            this.activeLotImgLink = e.link
            document.getElementById('content' + id).style.borderColor = 'red'
          } else {
            document.getElementById('content' + e.id).style.borderColor = 'transparent'
          }
        })
      })
    },

    /**
     * 父组件调用
     */
    queryInfoByLotId(id) {
      if (this.outData.round === 0) {
        this.$set(this, 'activeQuoted', parseFloat(this.outData.currentQuoted));
      } else {
        const result = parseFloat(this.outData.currentQuoted) + parseFloat(this.outData.bidIncrement);
        this.$set(this, 'activeQuoted', result.toFixed(2));
      }
      if (this.countDownTimer) {
        clearInterval(this.countDownTimer)
      }
      this.formatTime();
      // 开拍前倒计时（auctionStatus==0时检查）
      this.checkStartCountdown();
      console.log('---', id);

      if (this.mediaList && this.mediaList.length > 0) {
        this.$nextTick(() => {
          this.changeShowMedia(this.mediaList[0].id, 0);
          // 媒体切换完成后设置加载完成
          this.$nextTick(() => {
            this.mediaLoading = false;
          });
        });
      } else {
        // 没有媒体文件时也要结束加载状态
        this.mediaLoading = false;
      }

      // 关闭视频（确保初始状态）
      this.closeVideo();

    },

    formatTime() {
      if (this.outData.auctionStatus === 1) {
        this.activeTimeCountDown = this.outData.timeRemaining - (new Date().getTime() / 1000 - new Date(this.outData.executeTime).getTime() / 1000)
        this.countDownTimer = setInterval(() => {
          if (this.activeTimeCountDown > 0) {
            this.activeTimeCountDown--;
            this.countDown = {
              day: parseInt(this.activeTimeCountDown / (24 * 60 * 60)),
              hour: parseInt(this.activeTimeCountDown / (60 * 60) % 24),
              minute: parseInt(this.activeTimeCountDown / 60 % 60),
              second: parseInt(this.activeTimeCountDown % 60)
            }
          }
        }, 1000)
      } else {
        this.activeTimeCountDown = this.outData.timeRemaining
        this.countDown = {
          day: parseInt(this.activeTimeCountDown / (24 * 60 * 60)),
          hour: parseInt(this.activeTimeCountDown / (60 * 60) % 24),
          minute: parseInt(this.activeTimeCountDown / 60 % 60),
          second: parseInt(this.activeTimeCountDown % 60)
        }
      }
    },

    // 倒计时结束回调——通知父组件刷新标的详情数据
    onCountdownEnd() {
      this.$emit('refresh-lot-data');
    },

    // 开拍倒计时结束回调——退回静态文本，同时尝试刷新数据
    onStartCountdownEnd() {
      this.showStartCountdown = false;
      this.$emit('refresh-lot-data');
    },

    // 开拍前倒计时检查：距离开拍10分钟内显示倒计时
    checkStartCountdown() {
      // 先清除之前的检查定时器
      if (this.startCountdownCheckTimer) {
        clearInterval(this.startCountdownCheckTimer);
        this.startCountdownCheckTimer = null;
      }
      if (!this.meetingData || !this.meetingData.startAuctionTime) return;
      const startTs = new Date(this.meetingData.startAuctionTime).getTime();
      const check = () => {
        const now = Date.now();
        const diffMs = startTs - now;
        if (diffMs > 0 && diffMs <= 10 * 60 * 1000) {
          // 距离开拍10分钟内，显示倒计时
          this.showStartCountdown = true;
          // 进入倒计时后无需再检查
          if (this.startCountdownCheckTimer) {
            clearInterval(this.startCountdownCheckTimer);
            this.startCountdownCheckTimer = null;
          }
        }
      };
      check();
      // 如果还没进入10分钟窗口，每秒检查一次
      if (!this.showStartCountdown) {
        this.startCountdownCheckTimer = setInterval(check, 1000);
      }
    },

    // 打开全屏模态框（新增）
    openFullscreen() {
      if (!this.isCurrentVideo) {
        this.fullscreenVisible = true;
      }
    },

    // 关闭全屏模态框（新增）
    closeFullscreen() {
      this.fullscreenVisible = false;
    },

    // 监听键盘ESC键退出全屏（新增）
    handleKeydown(event) {
      if (event.key === 'Escape' && this.fullscreenVisible) {
        this.closeFullscreen();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.mediaLoading && this.mediaList && this.mediaList.length > 0) {
        this.mediaLoading = false;
      }
    });
    // 组件挂载后，为所有输入框添加额外保护
    this.$nextTick(() => {
      const inputElements = document.querySelectorAll('.no-manual-input .el-input__inner');
      inputElements.forEach(input => {
        // 设置输入框为只读
        input.readOnly = true;
        // 移除输入事件监听
        input.removeEventListener('input', () => {
        });
        // 添加输入阻止
        input.addEventListener('input', this.handleInput);
        // 阻止粘贴
        input.addEventListener('paste', (e) => e.preventDefault());
        // 阻止拖拽
        input.addEventListener('drop', (e) => e.preventDefault());
      });
    });
    // 监听键盘ESC键（新增）
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    // 移除键盘事件监听（新增）
    document.removeEventListener('keydown', this.handleKeydown);
    // 清除开拍前倒计时检查定时器
    if (this.startCountdownCheckTimer) {
      clearInterval(this.startCountdownCheckTimer);
      this.startCountdownCheckTimer = null;
    }
  },
  created() {
    this.auctionModalityOptions = auctionModalityOptions;
    if (this.isLogin) {//如果登陆了就判断是否报名
      this.getApplyState();
    }
    this.mediaLoading = true;
  }
}
</script>

<style scoped>
.bidder-info {
  margin-left: 8px;
  font-size: 14px;
  color: #666;
}

.bidder-self {
  color: #007AFF; /* 蓝色表示本人 */
  font-weight: 500;
}

.bidder-code {
  color: #E6A23C; /* 橙色表示其他竞买人 */
}

.no-manual-input .el-input__inner {
  pointer-events: none; /* 禁止鼠标事件 */
  user-select: none; /* 禁止文本选择 */
  background-color: #f5f7fa; /* 可选：添加背景色区分 */
}

/* 保证金信息样式  */
.deposit-info {
  margin-top: 0px;
  text-align: center;
  color: #666;
  font-size: 12px;
  padding: 5px 0;
  background-color: rgba(243, 245, 247, 0.5);
  border-radius: 4px;
  width: 100%;
  margin-left: 60px; /* 与按钮对齐 */
  margin-right: 60px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: visible; /* 改为 visible，让超出部分显示 */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 22px;
}

.deposit-text {
  white-space: nowrap;
  overflow: visible;
  display: inline-block;
}

.deposit-info strong {
  color: #e6a23c;
  font-weight: 600;
}

/* 保证金信息悬停效果 */
.deposit-info:hover {
  background-color: rgba(243, 245, 247, 0.8);
}

.quoted-apply .deposit-info {
  margin-left: 0; /* 未登录状态不需要左外边距 */
  margin-right: 0;
  width: auto; /* 改为自动宽度 */
  min-width: 150px; /* 最小宽度与按钮同宽 */
  max-width: 100%; /* 最大宽度为100% */
  margin: 5px auto 0; /* 居中显示 */
  padding-left: 10px;
  padding-right: 10px;
}

/* 线下拍卖平台信息样式 */
.offline-platform-info {
  width: 525px;
  padding: 20px 60px;
  text-align: center;
  background: rgba(243, 245, 247, 0.8);
  border-radius: 8px;
  margin-top: 20px;
}

.platform-text {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 1.5;
  margin-bottom: 10px;
}

.platform-text i {
  color: #007AFF;
  margin-right: 8px;
  font-size: 18px;
}

.platform-name {
  color: #E6A23C;
  font-weight: 600;
  padding: 0 4px;
}

.platform-tips {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  background: rgba(255, 255, 255, 0.6);
  padding: 8px 12px;
  border-radius: 4px;
  border-left: 3px solid #007AFF;
}

.platform-tips i {
  color: #007AFF;
  margin-right: 6px;
}

.lot-content-info-row {
  height: 30px;
  width: 525px;
}

.span3-value {
  display: inline-block;
  width: 98px;
  height: 30px;
  opacity: 1;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 238, 245, 1);
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(0, 0, 0, 1);
  text-align: center;
}

.span3-label {
  display: inline-block;
  width: 73px;
  height: 30px;
  opacity: 1;
  background: rgba(243, 245, 247, 1);
  border: 1px solid rgba(235, 238, 245, 1);
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.lot-content-info-div {
  margin-top: 15px;
  width: 525px;
  height: 120px;
}

.price-div-class {
  margin-left: 20px;
  margin-top: 20px;
  height: 27px;
}

.lot-content-quoted-div {
  overflow: hidden;
  margin-top: 15px;
  width: 525px;
  height: 150px;
  opacity: 1;
  border-radius: 5px;
  background: rgba(243, 245, 247, 1);
}

.ready-type-span-class {
  display: inline-block;
  width: 76px;
  height: 28px;
  border-radius: 2px;
  background: rgba(30, 169, 106, 1);
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.end-type-span-class {
  display: inline-block;
  width: 60px;
  height: 28px;
  border-radius: 2px;
  background: rgba(214, 54, 59, 1);
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.time-type-div {
  margin-top: 20px;
  width: 525px;
  height: 28px;
  opacity: 1;
}

.view-count-value {
  display: inline-block;
  /** 文本1 */
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(153, 153, 153, 1);
}

.view-count-label {
  display: inline-block;
  /** 文本2 */
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(0, 0, 0, 1);
}

.eye-img-class {
  margin-top: -5px;
  margin-right: 5px;
  margin-left: 20px;
  width: 20px;
  height: 20px;
  opacity: 1;
}

.view-count-div {
  margin-top: 20px;
  width: 400px;
  height: 20px;
}

.small-img-div {
  margin-top: 10px;
  width: 400px;
  height: 60px;
  opacity: 1;
  overflow: hidden;
  background: rgba(243, 245, 247, 1);
}

.lot-content-right {
  margin-left: 30px;
  display: inline-block;
  width: 525px;
  height: 380px;
  vertical-align: bottom;
}

.lot-content-left {
  display: inline-block;
  width: 400px;
  height: 380px;
  vertical-align: bottom;
}

.big-img-div {
  margin-top: 20px;
  width: 400px;
  height: 220px;
  z-index: 1000;
}

.lot-content-div {
  display: inline-block;
  margin-left: 30px;
  width: 960px;
  height: 380px;
  vertical-align: bottom;
}

.lot-title-div {
  margin-left: 30px;
  width: 960px;
  height: 60px;
  opacity: 1;
  border-bottom: 1px solid rgba(233, 237, 242, 1);
  /** 文本1 */
  font-size: 24px;
  font-weight: 500;
  line-height: 60px;
  color: rgba(0, 0, 0, 1);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.result_span {
  margin-top: 8px;
  margin-left: 183px;
  width: 160px;
  height: 40px;
  border-radius: 4px;
  background: rgba(254, 240, 240, 1);
  border: 1px solid rgba(214, 54, 59, 1);
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: rgba(214, 54, 59, 1);
}

.from-value {
  color: #333;
}

.from-quoted {
  color: rgb(153, 153, 153);
  line-height: 25px;
}

.el-row-from {
  margin-top: 10px;
}

.servicefeetips {
  line-height: 30px;
  margin-top: 20px;
  height: 30px;
  background-color: rgb(243, 245, 247);
}

.quoted-apply {
  margin-top: 5px;
  text-align: center;
}

.price-value {
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(214, 54, 59, 1);
  margin-left: 5px;
}

.price-label {
  min-width: 50px;
  /** 文本1 */
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 26.06px;
  color: rgba(0, 0, 0, 1);
}

.quoted-div {
  margin-top: 10px;
  line-height: 45px;
  width: 450px;
  height: 150px;
  background-color: rgb(243, 245, 247);
}

.content-time {
  margin-left: 20px;
}

.content-info {
  margin-top: 30px;
}

.content-img-div {
  margin-top: 30px;
}

.content-img-dom {
  display: inline-block;
  margin: 0 2px;
  border: 1px solid transparent;
  width: 67px;
  height: 50px;
  opacity: 0.6;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0; /* 防止图片被压缩 */
}

.content-img-dom:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.content-img-dom.active-img {
  opacity: 1;
  border-color: red;
}

.content-img-li {
  display: inline;
  margin-left: 10px;
  margin-right: 10px;
}

.flex-row {
  display: flex;
}

/* 图片导航按钮样式 */
.small-img-div {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  width: 400px;
  height: 60px;
  opacity: 1;
  overflow: hidden;
  background: rgba(243, 245, 247, 1);
}

.nav-btn {
  z-index: 10;
  margin: 0 2px;
  background-color: rgba(255, 255, 255, 0.3); /* 半透明背景 */
  border: 1px solid rgba(200, 200, 200, 0.5); /* 半透明边框 */
  width: 24px; /* 窄按钮 */
  height: 36px; /* 窄按钮 */
  padding: 3px;
  transition: all 0.3s ease;
}

.nav-btn:hover:not([disabled]) {
  background-color: rgba(255, 255, 255, 0.6); /* 悬停时更不透明 */
  border-color: rgba(200, 200, 200, 0.8);
}

.nav-btn[disabled] {
  opacity: 0.3; /* 禁用时更透明 */
  cursor: not-allowed;
}

.nav-btn-left {
  margin-right: 2px;
}

.nav-btn-right {
  margin-left: 2px;
}

.nav-btn .el-icon-arrow-left,
.nav-btn .el-icon-arrow-right {
  font-size: 12px; /* 减小箭头图标大小 */
}

.img-list-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  overflow: hidden;
  margin: 0 5px;
}

.img-scroll-wrapper {
  display: flex;
  transition: transform 0.3s ease;
  transform: translateX(0); /* 初始位置 */
}

/* 视频显示区域 */
.video-display {
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.video-display video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 视频控制栏 */
.video-controls {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(0, 0, 0, 0.7);
  padding: 5px 15px;
  border-radius: 20px;
  color: white;
  z-index: 10;
}

.video-duration {
  font-size: 12px;
  color: #fff;
  margin: 0 5px;
}

/* 视频占位符 */
.video-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #666;
  font-size: 14px;
}

/* 视频缩略图预览样式 */
.video-thumb-preview {
  position: relative;
  overflow: hidden;
  background: #000;
}

.video-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.video-play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  color: white;
}

.video-play-overlay i {
  font-size: 20px;
}

.video-thumb:hover .video-play-overlay {
  background: rgba(0, 0, 0, 0.5);
}

/* 全屏对话框样式 */
.fullscreen-dialog {
  margin: 0 !important;
  background: rgba(0, 0, 0, 0.95);
}

.fullscreen-dialog .el-dialog__header {
  display: none;
}

.fullscreen-dialog .el-dialog__body {
  padding: 0;
  height: 100vh;
  background: transparent;
}

.fullscreen-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.95);
}

.fullscreen-header {
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.8);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.fullscreen-title {
  display: flex;
  align-items: center;
  gap: 20px;
  color: white;
  font-size: 18px;
  font-weight: 500;
}

.fullscreen-counter {
  font-size: 14px;
  color: #aaa;
}

.fullscreen-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fullscreen-nav-btn {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.fullscreen-nav-btn:hover:not([disabled]) {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.fullscreen-close-btn {
  color: white !important;
  font-size: 14px;
  margin-left: 10px;
}

.fullscreen-close-btn:hover {
  color: #f56c6c !important;
}

.fullscreen-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.fullscreen-image {
  max-width: 100%;
  max-height: calc(100vh - 100px);
  object-fit: contain;
  cursor: zoom-out;
  transition: transform 0.3s ease;
}

.fullscreen-image:hover {
  transform: scale(1.01);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .fullscreen-header {
    padding: 0 10px;
    height: 50px;
  }

  .fullscreen-title {
    font-size: 16px;
  }

  .fullscreen-actions {
    gap: 5px;
  }

  /* 保证金信息响应式调整 */
  .deposit-info {
    margin-left: 10px;
    margin-right: 10px;
    font-size: 11px;
  }

  /* 线下拍卖平台信息响应式调整 */
  .offline-platform-info {
    width: 100%;
    padding: 15px 20px;
    margin-left: 0;
    margin-right: 0;
  }

  .platform-text {
    font-size: 14px;
  }

  .platform-tips {
    font-size: 12px;
  }

  .offline-platform-info-simple {
    margin-top: 10px;
    margin-left: 20px; /* 与起拍价对齐 */
    text-align: left;
  }

  .offline-platform-info-simple .platform-text {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
    margin-bottom: 5px;
    word-break: break-word;
    white-space: normal;
  }

  .offline-platform-info-simple .platform-name {
    color: #E6A23C;
    font-weight: 600;
  }

  .offline-platform-info-simple .platform-tips {
    font-size: 12px;
    color: #666;
    line-height: 1.3;
    background: rgba(243, 245, 247, 0.6);
    padding: 6px 10px;
    border-radius: 4px;
    border-left: 2px solid #007AFF;
  }
}

.loading-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
}

/* 确保视频占位符样式一致 */
.video-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #666;
  font-size: 14px;
  cursor: pointer;
}

.video-placeholder:hover {
  background: #eee;
}

.meeting-platform-info {
  display: block;
  margin: 5px auto 0;
  padding: 5px 15px;
  background-color: #ecf5ff;
  border: 2px solid #b3d8ff;
  border-radius: 6px;
  color: #409eff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  word-break: break-all;
  line-height: 1.5;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
  min-width: 250px;
  max-width: fit-content;
}

</style>
